import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PointerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2.82486 2.04183L11.8217 5.50217C12.231 5.65957 12.3427 6.18609 12.0327 6.49613L10.1429 8.42857L13.8813 12.4865C14.0596 12.7277 14.0346 13.0631 13.8225 13.2751L13.2751 13.8225C13.0631 14.0346 12.7277 14.0596 12.4865 13.8813L8.42857 10.1429L6.49613 12.0327C6.18609 12.3427 5.65957 12.231 5.50217 11.8217L2.04183 2.82486C1.85336 2.33484 2.33484 1.85336 2.82486 2.04183Z"
		></path>
	</svg>
))
